import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AnalyticsEvent, AnalyticsEventObject, AnalyticsPageView, IAnalyticsAdapter, PROListAnalyticsAdapter } from "../../services/Analytics";
import { HeadService } from "../../services/HeadService";
import { ServiceManager, ServiceType } from "../../services/ServiceManager";
import { RouteMeta } from "../meta";

interface ViewBase {
  getAnalyticsEvent?(): AnalyticsEvent | null;
  getAnalyticsData?(): AnalyticsEventObject | null;
  head?(): RouteMeta | Promise<RouteMeta> | null;
}

@Component
class ViewBase extends Vue {
  protected prolistAnalyticsService = ServiceManager.Get<PROListAnalyticsAdapter>(ServiceType.Analytics, 'PROListAnalyticsAdapter');
  protected headService = ServiceManager.Require<HeadService>(ServiceType.Head)!;

  public updateAnalytics() {
    let evt: AnalyticsEvent | null = null;
    let obj: AnalyticsEventObject | null = null;

    if (typeof this.getAnalyticsEvent !== 'undefined') {
      evt = this.getAnalyticsEvent.call(this);
    } else if(typeof this.getAnalyticsData !== 'undefined') {
      obj = this.getAnalyticsData.call(this);
    }

    if (evt === null) evt = new AnalyticsPageView(this.$route.path, this.$route.name || '', obj || undefined);

    this.triggerAnalyticsEvent(evt);
  }

  public triggerAnalyticsEvent(event: AnalyticsEvent) {
    ServiceManager.GetAll<IAnalyticsAdapter>(ServiceType.Analytics).forEach((adapter) => {
      adapter.Record(event);
    });
  }

  public triggerCustomAnalyticsEvent(event: AnalyticsEvent) {
    if (this.prolistAnalyticsService !== null) this.prolistAnalyticsService.Record(event);
  }

  protected updateHead() {
    if ('head' in this) {
      const result = this.head!.bind(this)();

      if(result instanceof Promise) {
        result.then((meta: RouteMeta | null) => {
          this.headService.Update(meta);
        });
      } else {
        this.headService.Update(result as RouteMeta | null);
      }
    } else {
      this.headService.UpdateWithStatic(this.$route.path);
    }
  }
}

@Component
class View extends ViewBase {
  public mounted() {
    requestAnimationFrame(() => {
      this.updateHead();
      this.updateAnalytics();
    });
  }
}

@Component
class AsyncView extends ViewBase {
  public mounted() {
    this.$on('updateView', () => {
      requestAnimationFrame(() => {
        this.updateHead();
        this.updateAnalytics();
      });
    });
  }
}

export {
  View,
  AsyncView
}
